import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Checkbox from "@material-ui/core/Checkbox";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

import { useStyles } from "../../../../../../Components/CSS/FormStyle.css";
import Axios from "axios";
import { url } from "../../../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../../Redux/Actions/actions";

class FeeFormStudent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        month: this.props.monthName,
        feeTypeName: "",
        price: "",
        discount: "",
        remarks: "",
        status: false,
      },
    };
  }

  componentDidMount() {
    if (this.props.editStatus) {
      this.setData(this.props.data);
    }
  }

  setData = (data) => {
    this.setState({
      data: {
        month: data.month,
        feeTypeName: data.feeTypeName,
        price: data.price,
        discount: data.discount ? data.discount : 0,
        remarks: data.remarks ? data.remarks : "",
        status: data.status ? data.status : false,
      },
    });
  };

  handleChangeStatus = (e) => {
    this.setState({
      data: { ...this.state.data, status: e.target.checked },
    });
  };

  handleChangeFeeType = (e) => {
    const filtered = this.props.initialFeeGroup.filter(
      (data) => data.feeTypeName === e.target.value
    );
    this.setState({
      data: {
        ...this.state.data,
        feeTypeName: filtered[0].feeTypeName,
        price: filtered[0].price,
      },
    });
  };

  handleChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  filterData = (data) => {
    let changedData = data;
    if (changedData.discount === "") {
      delete changedData.discount;
    }

    if (changedData.remarks === "") {
      delete changedData.remarks;
    }

    return changedData;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let data = this.filterData(this.state.data);
      const response = await Axios.put(
        `${url}/api/student-fees/${this.props.studentFeeId}/fee`,
        data,
        {
          headers: {
            Authorzation: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Fee added successfully to student") {
        this.setState({
          data: {
            ...this.state.data,
            month: this.props.monthName,
            feeTypeName: "",
            price: "",
            discount: "",
            remarks: "",
            status: false,
          },
        });
        this.props.getStudentFee(this.props.studentFeeId);
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  handleUpdate = async (e) => {
    e.preventDefault();
    try {
      let data = this.filterData(this.state.data);
      const response = await Axios.put(
        `${url}/api/student-fees/${this.props.studentFeeId}/fee/${this.props.data._id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (
        response.data.message === "Fee edited successfully in student fees list"
      ) {
        this.props.handleCancelEdit();
        this.props.getStudentFee(this.props.studentFeeId);
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleUpdate(e);
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <TableRow>
        <TableCell />
        {this.props.editStatus ? (
          <TableCell align="center">{this.state.data.feeTypeName}</TableCell>
        ) : (
          <TableCell align="center">
            <TextField
              name="feeTypeName"
              select
              required
              fullWidth
              variant="outlined"
              margin="normal"
              SelectProps={{ native: true }}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={this.state.data.feeTypeName}
              onChange={this.handleChangeFeeType}
            >
              <option value="">Select Any One</option>
              {this.props.initialFeeGroup.map((feeGroup, index) => (
                <option key={index} value={feeGroup.feeTypeName}>
                  {feeGroup.feeTypeName}
                </option>
              ))}
            </TextField>
          </TableCell>
        )}
        <TableCell align="center">
          {this.state.data.price ? this.state.data.price : 0}
        </TableCell>

        <TableCell align="center">
          <Checkbox
            checked={this.state.data.status}
            disableRipple
            onChange={this.handleChangeStatus}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name="discount"
            type="number"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.discount}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name="remarks"
            type="text"
            required
            fullWidth
            multiline
            rows={3}
            rowsMax={3}
            variant="outlined"
            margin="normal"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.remarks}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          {this.props.editStatus ? (
            <>
              <Tooltip
                arrow
                title="Update"
                className={classes.tooltip}
                onClick={this.handleUpdate}
              >
                <CheckCircleIcon />
              </Tooltip>
              <Tooltip
                arrow
                title="Cancel"
                className={classes.tooltip}
                onClick={this.props.handleCancelEdit}
              >
                <CancelIcon />
              </Tooltip>
            </>
          ) : (
            <Tooltip
              arrow
              title="center"
              className={classes.tooltip}
              onClick={this.handleSubmit}
            >
              <AddCircleIcon />
            </Tooltip>
          )}
        </TableCell>
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(FeeFormStudent)));
